import { render } from "./CInternetConnection.vue?vue&type=template&id=115bcfd9&scoped=true"
import script from "./CInternetConnection.vue?vue&type=script&lang=js"
export * from "./CInternetConnection.vue?vue&type=script&lang=js"

import "./CInternetConnection.vue?vue&type=style&index=0&id=115bcfd9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115bcfd9"]])

export default __exports__